module.exports = __webpack_public_path__ + "static/Q5Answer5_Yellow_JoseLarrazolo-7406320859fcf61f0932ebcd63a14a72.jpg";